import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=0bd73054&scoped=true"
var script = {}
import style0 from "./whatsapp.vue?vue&type=style&index=0&id=0bd73054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd73054",
  null
  
)

export default component.exports